// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-o_fC","advertDetailContactGroup__header":"c-o_fE","advertDetailContactGroup__value":"c-o_fF"};